// extracted by mini-css-extract-plugin
export default {"root":"YGegOOualI2JiHXdqCZN","page":"bcy3zHoq7xXA0CpTbXUv"};